import { createAction } from 'redux-actions';
import { usePermValue } from 'src/containers/include/UserPermContext';
import GA from 'src/helpers/setGoogleAnalytics';
import { getArray } from 'utils';
export const UPDATE_STATE = 'AUTH_UPDATE_STATE';

// userinfo
export const updateStateAction = createAction(UPDATE_STATE);

export type LoginPayload = {
	userName: string;
	passWord: string;
};

export interface IUserInfo {
	advertiseId: any;
	advertiseName: any;
	agentId: number;
	agentType: string;
	customerId: string;
	isAdmin: string;
	isOutAgent: string;
	parentTypeId: string;
	permList: string[];
	permMap: any;
	role: string; // 0 代理商 1广告主
	rootAgentId: string;
	seatIdJson: any[];
	subAgentNum: string;
	token: string;
	userAgent: string;
	userId: string;
	userIp: string;
	userName: string;
	userType: string;
	yoyier: string;
	isVip: number;
}

export const setUserInfo = (userInfo) => async (dispatch) => {
	const permMap = usePermValue(getArray(userInfo, 'permList'));
	dispatch(updateStateAction({ ...userInfo, permMap }));
	GA.setParams({
		userId: userInfo.userId,
		userName: userInfo.userName
	});
};